define('views/leftnav/Podio.Views.LeftNav.OrgNav',['require','underscore','jquery','lib/backbone/Backbone.PodioView','views/leftnav/Podio.Views.LeftNav.OrgNavOrg','views/leftnav/Podio.Views.LeftNav.OrgNavOrgList','lib/Podio.Config'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var ViewOrgNavOrg = require('views/leftnav/Podio.Views.LeftNav.OrgNavOrg');
  var ViewOrgNavOrgList = require('views/leftnav/Podio.Views.LeftNav.OrgNavOrgList');
  var podioConfig = require('lib/Podio.Config');

  return ViewPodioBase.extend({
    initialize: function() {
      _.bindAll(this, 'bindEvents');

      this._super();

      this.organizations = this.options.organizations;
      this.currentOrganization = this.options.currentOrganization;
      this.collapsedOrganizations = this.collapsedOrganizationsFromCookie();

      this.bindEvents();
    },

    bindEvents: function() {
      this.eventBus.bind('leftnav:orgExpanded', this.onOrganizationExpanded, this);
      this.eventBus.bind('leftnav:orgCollapsed', this.onOrganizationCollapsed, this);
    },

    render: function() {
      this.elmOrgNav = this.elm.find('.org-navigation');
      this.renderOrganizations();
    },

    renderOrganizations: function() {

      if (!this.orgNavOrgListView) {
        this.orgNavOrgListView = new ViewOrgNavOrgList({
          elm: this.elmOrgNav,
          collection: this.organizations,
          eventBus: this.eventBus,
          currentOrganization: this.currentOrganization.get('id'),
          collapsedOrganizations: this.collapsedOrganizations
        });
      }

      this.orgNavOrgListView.render();

    },

    collapsedOrganizationsFromCookie: function() {
      var collapsedOrganizationsCookieValue = $.cookie('collapsed-orgs');
      if (collapsedOrganizationsCookieValue) {
        var list = [];
        _.map(collapsedOrganizationsCookieValue.split(','), function(val) {
          list.push(parseInt(val, 10));
        });
        return list;
      }
      return [];
    },

    onOrganizationExpanded: function(orgId) {
      this.collapsedOrganizations = _.reject(this.collapsedOrganizations, function(i) {
        return i === orgId;
      });

      this.storeCollapsedOrganizations();
    },

    onOrganizationCollapsed: function(orgId) {
      this.collapsedOrganizations.push(orgId);
      this.storeCollapsedOrganizations();
    },

    storeCollapsedOrganizations: function() {
      $.cookie('collapsed-orgs', _.uniq(this.collapsedOrganizations).join(','), {path: '/', domain: podioConfig.base_domain, expires: 365});
    }

  });
});

